import http from "../http-common";

class PaymentService {
  /** Get payments (optional: filter by client_payment_id) */
  getByClientPayment(clientPaymentId) {
    return http.get("/payments", { params: { client_payment_id: clientPaymentId } });
  }

  /** Create a payment for a client payment (membership) */
  create(data) {
    // Support optional file attachment via FormData
    if (data && data.attachment) {
      const form = new FormData();
      form.append('client_payment_id', data.client_payment_id);
      if (data.descount_id) form.append('descount_id', data.descount_id);
      form.append('monto', data.monto);
      form.append('mora', data.mora ? '1' : '0');
      form.append('efectivo', data.efectivo ? '1' : '0');
      form.append('cheque', data.cheque ? '1' : '0');
      form.append('tarjeta', data.tarjeta ? '1' : '0');
      form.append('attachment', data.attachment);
      return http.post("/payments", form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return http.post("/payments", data);
  }

  get(id) {
    return http.get(`/payments/${id}`);
  }
}

export default new PaymentService();
